// BSV CHANGES 
type Employee = {
  id: number;
  employeeCode: string;
  name: string;
  department: string;
  designation: string;
  mappedDivision: number[];
  isActive: boolean;
  startDate?: string;
  endDate?: string;
};

export const columns: {id: keyof Employee; label: string; width?: number}[] = [
  {id: 'employeeCode', label: 'Employee ID', width: 150},
  {id: 'name', label: 'Name', width: 150},
  {id: 'department', label: 'Department', width: 150},
  {id: 'designation', label: 'Designation', width: 150},
  {id: 'mappedDivision', label: 'Division', width: 130},
  {id: 'startDate', label: 'Start Date', width: 190},
  {id: 'endDate', label: 'End Date', width: 150},
  {id: 'isActive', label: 'Status', width: 180},
];